const hasHistory = typeof window !== 'undefined' && typeof window.history === 'object';

/**
 * attempt to go back in page history and fallback to the url specified
 */
export default function browserBack(fallbackUrl?: string): void {
  // [ZL] Use fallback URL if history does not have enough entries
  if (hasHistory && window.history.length > 1) {
    window.history.back();
    return;
  }

  if (fallbackUrl) {
    window.location.href = fallbackUrl;
  }
}
